import PropTypes from "prop-types";

export default {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	type: PropTypes.string,
};
